type WindowWithDataLayer = Window & {
  dataLayer?: {
    push: (event: Record<string, unknown>) => void;
  };
};

declare const window: WindowWithDataLayer;

export const dataLayer = (event: Record<string, unknown>) => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(event);
};
